module.exports = __webpack_public_path__ + "img/literacy_eles_banner1.708f4c04.png";